import { cn } from "@/lib/utils";
import { Printer } from "lucide-react";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Button, ButtonProps } from "../ui/button";

const PrintButton = forwardRef<
  HTMLButtonElement,
  ButtonProps & {
    hideText?: boolean;
    iconSize?: number;
    iconColor?: string;
    disabled?: boolean;
  }
>(
  (
    {
      className,
      hideText = false,
      iconSize = 16,
      iconColor = "#64748B",
      disabled = false,
      ...props
    },
    ref,
  ) => {
    const { t } = useTranslation();

    return (
      <Button
        ref={ref}
        variant="outline"
        className={cn("flex flex-row gap-2 items-center", className)}
        disabled={disabled}
        {...props}
      >
        <Printer size={iconSize} color={iconColor} />
        {!hideText && t("singleArtworkPrintBtn")}
      </Button>
    );
  },
);

export default PrintButton;
